export const headerData = {
  name: 'Shubham Dubey',
  title: 'Full Stack Engineer',
  description: 'Building scalable SaaS, AI-powered platforms, and real-time systems.',
  github: 'https://github.com/Luke0912',
  linkedIn: 'https://www.linkedin.com/in/shubhamluke09',
  email: 'shubhamdubey.dubey4@gmail.com',
}
